const centerPanel = require('../../shop/views/center-panel.view.html').trim(),
    rightPanel = require('../../shop/views/right-panel.view.html').trim();

module.exports = ($stateProvider) => {
    $stateProvider
        .state('shop.productdetails', {
            // temporary for old product description popup
            url: '/productdetails/:productId/:productName',
            params: {
                product: null,
            },
            data: {
                pageMetadata: [
                    'DetailProductService', 'PageMetadataService', '$stateParams',
                    function (detailProductService, pageMetadataService, $stateParams) {
                        return detailProductService.getProductDetail($stateParams.productId).then(details => pageMetadataService.getMetadata({
                            name: `${details.Product.Name} ${details.Product.PackageSize}`.trim(),
                        }, null, null, 'Product'));
                    },
                ],
            },
            onEnter: ['RichRelevanceService', '$stateParams', function (richRelevanceService, $stateParams) {
                if ($stateParams.product) {
                    richRelevanceService.rrItemDetailsPageRequest($stateParams.product.Stockcode, $stateParams.product.Source);
                }
            }],
            resolve: {
                modules: [
                    '$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load('productdetail');
                    },
                ],
            },
            views: {
                'content@root': {
                    template: `${centerPanel} ${rightPanel}`,
                },
                'center-panel@shop.productdetails': {
                    controller: ['DetailProductService', '$stateParams', function (detailProductService, $stateParams) {
                        if ($stateParams.product) {
                            this.detail = { Product: $stateParams.product };
                        }
                        detailProductService.getProductDetail($stateParams.productId).then((detail) => {
                            this.detail = detail;
                            this.isLoaded = true;
                        });
                    }],
                    controllerAs: '$ctrl',
                    template: '<wow-product-detail ng-if="$ctrl.detail" detail="$ctrl.detail" is-loaded="$ctrl.isLoaded"></wow-product-detail>',
                },
                'rr-instrumentation-panel@root': {
                    controller: ['$stateParams', 'Settings', 'RichRelevanceService',
                        function ($stateParams, settings, richRelevanceService) {
                            this.removeDuplicatedProducts = settings.richRelevance.removeDuplicatedProducts;
                            this.productId = $stateParams.productId;
                            this.productName = $stateParams.productName;
                            this.placementIds = `${richRelevanceService.itemPageRankOne}, ${richRelevanceService.itemPageRankTwo}`;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: '<wow-rr-item-instrumentation ng-if="!$ctrl.removeDuplicatedProducts" page-group="Category" item-id="$ctrl.productId" item-name="$ctrl.productName" placement-ids="$ctrl.placementIds"></wow-rr-item-instrumentation>',
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/productdetail.js